function initSwiper() {
  new Swiper('.swiper', { 
      slidesPerView: 'auto', // 改用 CSS 控制宽度
    freeMode: true,        // 允许自由滑动（避免强制对齐）
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}

document.addEventListener('DOMContentLoaded', initSwiper);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initSwiper);
  document.addEventListener('shopify:section:select', initSwiper);
}
